import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable';
import { ServiceBase } from 'app/shared/infrastructure';
import { environment } from 'environments/environment';

@Injectable()
export class SecuGenService extends ServiceBase {

    constructor(private _http: HttpClient) {
        super();
    }

    patientFingerprint = (): Observable<any> => {
        const headers = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded'
        });

        return this._http.post<any>(`${environment.SecuGenUrl}`,`${environment.SecuGenBody}`, { headers });
    }
}
